import React from "react";
import { Star } from "lucide-react";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" width="18" height="18" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M45.1 24.5c0-1.6-.1-2.8-.4-4H24v7.6h12c-.2 2-1.5 5-4.4 7l6.7 5.2c3.9-3.6 6.8-8.9 6.8-15.8z"
    />
    <path
      fill="#34A853"
      d="M24 46c5.9 0 10.9-2 14.3-5.7l-6.7-5.2c-1.8 1.3-4.3 2.2-7.6 2.2-5.9 0-10.9-3.9-12.7-9.3l-7 5.4C7.8 41 15.3 46 24 46z"
    />
    <path fill="#FBBC05" d="M11.3 28c-.5-1.4-.8-2.9-.8-4.5s.3-3.1.8-4.5l-7-5.4C3.5 16.6 2.7 20.2 2.7 24s.8 7.4 2.3 10.4l6.3-6.4z" />
    <path
      fill="#EA4335"
      d="M24 10.2c4.2 0 7 1.8 8.6 3.3l6.3-6.1C35 3.9 30 1.9 24 1.9 15.3 1.9 7.8 6.9 5 14.1l6.3 5.4C13.1 14.1 18.1 10.2 24 10.2z"
    />
  </svg>
);

export const GoogleBadge = ({ rating, sub }) => (
  <div
    data-testid="google-badge"
    className="inline-flex items-center gap-3 rounded-md border border-white/14 bg-white/[0.05] px-4 py-2.5"
  >
    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white">
      <GoogleG />
    </span>
    <span className="flex gap-[3px]">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star key={i} size={13} strokeWidth={0} className="fill-[#FBBC05]" />
      ))}
    </span>
    <span className="leading-tight">
      <span className="block text-[14px] font-semibold text-white">{rating}</span>
      <span className="block text-[12px] text-white/55">{sub}</span>
    </span>
  </div>
);
